// Dictation through the browser's own speech recognition (on the iPhone it is Apple's, as in the keyboard).
interface Alternative { transcript: string }
interface Result { isFinal: boolean; 0: Alternative }
interface Recognition {
  lang: string;
  continuous: boolean;
  interimResults: boolean;
  start(): void;
  stop(): void;
  onresult: ((e: { results: ArrayLike<Result> }) => void) | null;
  onerror: ((e: { error: string }) => void) | null;
  onend: (() => void) | null;
}
type RecognitionCtor = new () => Recognition;

const ctor = (): RecognitionCtor | undefined => {
  if (typeof window === 'undefined') return undefined;
  const w = window as unknown as { SpeechRecognition?: RecognitionCtor; webkitSpeechRecognition?: RecognitionCtor };
  return w.SpeechRecognition ?? w.webkitSpeechRecognition;
};

export const speechSupported = () => !!ctor();

const failures: Record<string, string> = {
  'not-allowed': 'Нет доступа к микрофону — разрешите его в настройках браузера',
  'service-not-allowed': 'Нет доступа к микрофону — разрешите его в настройках браузера',
  'audio-capture': 'Микрофон не найден',
  network: 'Голосовой ввод недоступен без сети',
};

/**
 * Listens until `stop()` or a pause the browser decides on. `onText` gets everything heard in this
 * session so far, interim words included; `final` is true when the browser has settled every word.
 */
export function listen(onText: (heard: string, final: boolean) => void, onEnd: (error?: string) => void): () => void {
  const Ctor = ctor();
  if (!Ctor) { onEnd('Голосовой ввод в этом браузере недоступен'); return () => {}; }
  const rec = new Ctor();
  rec.lang = 'ru-RU';
  rec.continuous = true;
  rec.interimResults = true;
  let failure: string | undefined;
  rec.onresult = (e) => {
    let heard = '';
    let final = true;
    for (let i = 0; i < e.results.length; i++) {
      heard += ' ' + e.results[i][0].transcript;
      if (!e.results[i].isFinal) final = false;
    }
    onText(heard.replace(/\s+/g, ' ').trim(), final);
  };
  rec.onerror = (e) => { if (e.error !== 'no-speech' && e.error !== 'aborted') failure = failures[e.error] ?? 'Голосовой ввод прервался'; };
  rec.onend = () => onEnd(failure);
  try { rec.start(); } catch { onEnd('Голосовой ввод не запустился'); }
  return () => { try { rec.stop(); } catch { /* already stopped */ } };
}
